// extracted by mini-css-extract-plugin
module.exports = {"notification":"notification_1BHVl"};